import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "@teamhanko/hanko-elements";
import styles from "./Todo.module.css";

const api = process.env.REACT_APP_HANKO_API!;

function HankoAuth() {
  const navigate = useNavigate();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    register(api)
      .then(({ hanko }) => {
        hanko.onSessionCreated(() => {
          navigate("/todo", { replace: true });
        });
      })
      .catch(setError);
  }, [navigate]);

  return (
    <div className={styles.content}>
      <div className={styles.error}>{error?.message}</div>
      <hanko-auth />
    </div>
  );
}

export default HankoAuth;
